















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { Preference } from '@/models/admin/prefrences';
import { Base } from '@/components/common/base';
import { preferenceService } from '@/shared';
import { ValidationRules } from '@/helper/enum';
@Component({
    props: ['methodName', 'progress'],
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },
})
export default class AddPreferencePage extends Base {
    public preference: Preference = {
        key: '',
        value: '',
    };
    public form: any = {};
    public formFields: Array<VFields<any>> = [];
    public disableSubmitButton: boolean = false;

    public beforeDestroy() {
        const buttons = [];
        this.$emit('updateToolBar', buttons);
    }
    public callMethod(methodName): void {
        if (methodName === 'backToList') {
            this.$router.push({ name: 'admin.preferences' });
        }
        if (methodName === 'submitPreference') {
            if (!this.form.$valid) {
                this.showAlert(false, 'Form is Invalid!');
                this.resetMethodName(methodName);
                return;
            }
            this.submitPreference();
        }
        this.resetMethodName(methodName);
    }
    public resetMethodName(methodName): void {
        if (methodName !== '') {
            this.$emit('resetMethodName', methodName);
        }
    }
    public updateToolBar(): void {
        const buttons: any = [];
        buttons.push({ id: '0', type: 'button', title: this.$parent.$t('preferences.btnBack'), disabled: false, visible: true, class: 'btn', label: this.$parent.$t('preferences.btnBack'), click: 'backToList', icon: 'fas fa-arrow-left' });
        this.$emit('updateToolBar', buttons);
    }
    public async mounted(): Promise<void> {
        // activating tab
        this.$root.$emit('sidebar.layout.vue', 'preferences');

        // Toolbar
        this.updateToolBar();
        this.$watch('methodtoCall', (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });

        this.formFields = [
            {
                key: 'key',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    counter: 30,
                    label: this.$t('preferences.preferencesFields.key') as string,
                    required: true,
                    disabled: this.$route.params.key ? true : false,
                    loading: false,
                    rules: [
                        v => this.required('Key', v)
                    ]
                },
            },
            {
                key: 'value',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    counter: 200,
                    label: this.$t('preferences.preferencesFields.value') as string,
                    required: true,
                    disabled: false,
                    loading: false,
                    rules: [
                        v => this.required('Value', v)
                    ]
                },
            },
        ];
        if (this.$route.params.key) {
            try {
                this.formlyShowSkeleton(this.formFields);
                const preference = await preferenceService.getAsync(this.$route.params.key);
                this.preference = preference;
            } finally {
                this.formlyHideSkeleton(this.formFields);
            }
        }

    }

    public validatePreference(): Vue & { validate: () => boolean } {
        return this.$refs.preferenceForm as Vue & { validate: () => boolean };
    }

    public async submitPreference(): Promise<void> {
        if (this.validatePreference().validate()) {
            try {
                this.disableSubmitButton = true;
                this.$emit('update:progress', this.disableSubmitButton);
                if (this.$route.params.key) {
                    await preferenceService.updateAsync(this.preference);
                    this.showAlert(true, this.$t('preferences.alertUpdatePreference'));
                    this.$router.push({ name: 'admin.preferences' });
                } else {
                    await preferenceService.addAsync(this.preference);
                    this.showAlert(true, this.$t('preferences.alertSavePreference'));
                    this.$router.push({ name: 'admin.preferences' });
                }
            } finally {
                this.disableSubmitButton = false;
                this.$emit('update:progress', this.disableSubmitButton);
            }
        }
    }
}
